import { render } from "./PageSearch.vue?vue&type=template&id=396fc99e"
import script from "./PageSearch.vue?vue&type=script&lang=js"
export * from "./PageSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/Components/PageSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "396fc99e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('396fc99e', __exports__)) {
    api.reload('396fc99e', __exports__)
  }
  
  module.hot.accept("./PageSearch.vue?vue&type=template&id=396fc99e", () => {
    api.rerender('396fc99e', render)
  })

}


export default __exports__